import { call, put, select, all } from 'redux-saga/effects';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;

export function* createFieldChange(action) {
  const serverConfig = yield select(getServerConfig);
  const { fieldDefinition, survey, fieldChange } = action.payload;

  if (fieldChange.categories) {
    yield all(
      fieldChange.categories.map((category) =>
        put({
          ...action,
          payload: {
            ...action.payload,
            fieldChange: {
              ...fieldChange,
              text_value: category,
              categories: undefined,
            },
          },
        })
      )
    );

    return;
  }
  try {
    const path = `/survey/${serverConfig.namespace}/${survey.id}/change/${fieldDefinition.id}`;

    const result = yield call(API, 'post', 'api', path, {
      body: fieldChange,
    });

    yield put({
      type: 'ADD_FIELD_CHANGE',
      payload: {
        surveyId: survey.id,
        surveyParcelId: result.field_change.survey_parcel_id,
        fieldChange: result.field_change,
      },
    });
  } catch (e) {
    console.error(e);
  }
}
